import { Outlet } from "react-router";

const Home = () => {
  return (
    <div className="flex flex-col items-center">
      {/* Home page */}
      <img
        className="min-w-full"
        src="https://uomdai19172.files.wordpress.com/2019/11/sunset1.jpg?w=1024"
        alt="Sunset"
      ></img>
      <Outlet></Outlet>
    </div>
  );
};

export default Home;
